export default __webpack_public_path__ + "static/media/flag-1.f8895819.png";